import React from "react";

const CutFileWhy = () => {
  return (
    <div className="nailExtensionMaintain">
      <h5>Why Bangalorean’s Love Our Nails Cut & File in Bangalore</h5>
      <p>
        Residents of Bangalore appreciate the meticulous care and professional
        service offered by our Nails Cut & File in Bangalore. Here's why it's a
        favorite among our clients:
      </p>
      <ul>
        <li>
          <h6> Attention to Detail:</h6> Our technicians take great care to
          ensure every detail is perfect, from the length and shape of your
          nails to the smoothness of the edges.
        </li>
        <li>
          <h6>Convenience: </h6> Located in the heart of Bangalore, SCENT is
          easily accessible, making it convenient for you to enjoy a relaxing
          pedicure without having to travel far.
        </li>
        <li>
          <h6>Exceptional Service: </h6> Our commitment to providing exceptional
          service ensures that every visit to{" "}
          SCENT is a memorable and
          enjoyable experience.
        </li>
      </ul>
    </div>
  );
};

export default CutFileWhy;
